"use strict";

exports.__esModule = true;
exports.default = recursiveBracket;

/**
 * Formatte un ensemble de valeur en ajoutant des crochets autours de chaque valeur
 *   à partir de la seconde valeur.
 */
function recursiveBracket(values) {
  let output = "";

  for (const i of Object.keys(values)) {
    const value = values[i];

    if (i > 0) {
      output += `[${value}]`;
    } else {
      output += value;
    }
  }

  return output;
}